import React from 'react'
import { Row, Col } from 'react-bootstrap';
import './WinPrizes.css';

import winDreamPrize from '../images/win-pic-dream-prize.png';
import winLuckyDrawPrize from '../images/win-pic-lucky-draw-prize.png';
import winSignedMerchandise from '../images/win-pic-signed-merchandise.png';

function WinPrizes() {
    let pathName = window.location.pathname;
    return (
        <div>
            <div className="text-center win-sub-title-wrapper">
                <h2 className="sub-title sub-title-orange">Win exciting prizes!</h2>
            </div>
            <Row className="mb-5 text-center text-md-left">
                <Col md={6} className="my-4">
                    <Row className="no-gutters align-items-center">
                        <Col lg={5} className="text-center">
                            <img src={winDreamPrize} className="img-fluid" alt="" />
                        </Col>
                        <Col lg={7}>
                            <p><em>
                                {(() => {
                                    if (pathName === '/onlinechallenge') {
                                        return (
                                            <span className="win-prize-title"><strong>1</strong> Wild Card Winner</span>);
                                    } else {
                                        return (
                                            <span className="win-prize-title"><strong>11</strong> lucky winners</span>);
                                    }
                                })()}
                                will get a chance to learn cricket from <strong>M.S. Dhoni and Hardik Pandya</strong></em></p>
                        </Col>
                    </Row>
                </Col>
                <Col md={6} className="my-4">
                    <Row className="no-gutters align-items-center">
                        <Col lg={5} className="text-center">
                            <img src={winLuckyDrawPrize} className="img-fluid" alt="" />
                        </Col>
                        <Col lg={7}>
                            <p><em><span className="win-prize-title"><strong>50</strong> lucky winners</span> will get a chance to meet and greet the <strong>Chennai Super Kings team</strong></em></p>
                        </Col>
                    </Row>
                </Col>
                <Col md={{ span: 6, offset: 3 }} className="my-4">
                    <Row className="no-gutters align-items-center">
                        <Col lg={5} className="text-center">
                            <img src={winSignedMerchandise} className="img-fluid" alt="" />
                        </Col>
                        <Col lg={7}>
                            <p><em><span className="win-prize-title"><strong>100</strong> lucky winners</span> Win merchandise signed by <strong>M. S. Dhoni and Hardik Pandya</strong></em></p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default WinPrizes;